// extracted by mini-css-extract-plugin
export var readonly = "_fc-1";
export var star = "_fc-0";